var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"markdown-container",domProps:{"innerHTML":_vm._s(_vm.renderedMarkdown)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }